import { Link } from 'react-router-dom';

export function TermsPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Términos y Condiciones</h1>
      <p className="text-sm text-gray-500 mb-8">Última actualización: agosto 2026</p>

      <div className="prose prose-gray max-w-none space-y-6 text-gray-700 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">1. Aceptación de los Términos</h2>
          <p>
            Al acceder y utilizar la plataforma DonaApp (en adelante "la Plataforma"), operada por OVIEDOTECH S.A.S., 
            identificada con NIT 901.964.524-2, con domicilio en Cali, Valle del Cauca, Colombia, usted acepta estos 
            Términos y Condiciones en su totalidad. Si no está de acuerdo, le solicitamos no utilizar la Plataforma.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">2. Descripción del Servicio</h2>
          <p>
            DonaApp es una plataforma tecnológica que facilita la conexión entre personas u organizaciones que necesitan 
            productos o bienes en especie (organizadores de campañas) y personas que desean donar dichos productos (donantes). 
            DonaApp NO procesa pagos monetarios ni actúa como intermediario financiero.
          </p>
          <p>
            La Plataforma permite crear campañas de donación en especie, publicar listas de productos necesarios, y 
            registrar compromisos de donación que luego se coordinan directamente entre las partes.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">3. Registro y Cuentas de Usuario</h2>
          <p>
            Para crear campañas es necesario registrarse proporcionando información veraz y actualizada. El usuario es 
            responsable de mantener la confidencialidad de sus credenciales de acceso. Para realizar donaciones (compromisos) 
            no se requiere registro previo.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">4. Uso Aceptable</h2>
          <p>Los usuarios se comprometen a:</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>No crear campañas con fines fraudulentos o engañosos.</li>
            <li>Proporcionar información veraz sobre las necesidades de la campaña.</li>
            <li>No utilizar la plataforma para actividades ilegales.</li>
            <li>Respetar los compromisos de donación adquiridos.</li>
            <li>No suplantar identidades de terceros.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">5. Verificación de Campañas</h2>
          <p>
            DonaApp cuenta con un proceso de verificación administrado internamente. Las campañas que soliciten 
            visibilidad pública en el Marketplace serán revisadas por nuestro equipo antes de ser aprobadas. 
            La verificación no constituye una garantía absoluta, sino un esfuerzo razonable por validar la legitimidad 
            de la campaña.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">6. Responsabilidad de la Plataforma</h2>
          <p>
            DonaApp actúa exclusivamente como intermediario tecnológico. No somos responsables por la entrega efectiva 
            de los productos donados, ni por incumplimientos entre donantes y organizadores. Cada parte es responsable 
            de coordinar y cumplir con los compromisos adquiridos.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">7. Propiedad Intelectual</h2>
          <p>
            Todo el contenido de la Plataforma (diseño, código, marca, logos) es propiedad de OVIEDOTECH S.A.S. 
            El contenido subido por los usuarios (descripciones, imágenes de campañas) es responsabilidad de quien lo publica.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">8. Modificaciones</h2>
          <p>
            OVIEDOTECH S.A.S. se reserva el derecho de modificar estos términos en cualquier momento. Los cambios 
            serán notificados a través de la Plataforma y entrarán en vigor desde su publicación.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">9. Contacto</h2>
          <p>
            Para consultas sobre estos términos, puede escribirnos a{' '}
            <a href="mailto:contacto@donaapp.co" className="text-indigo-600 hover:underline">contacto@donaapp.co</a>.
          </p>
        </section>
      </div>

      <div className="mt-10 pt-6 border-t border-gray-200">
        <Link to="/" className="text-sm text-indigo-600 hover:underline">← Volver al inicio</Link>
      </div>
    </div>
  );
}
